<template>
  <g fill="#fff" :stroke="color" stroke-width="2">
    <path
      d="M14.929 15.99H2.07A1.07 1.07 0 0 1 1 14.92V2.07C1 1.48 1.48 1 2.071 1H14.93A1.07 1.07 0 0 1 16 2.07v12.85c0 .592-.48 1.07-1.071 1.07zM16 5.283H1M6.357 5.283V15.99"
    />
  </g>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: 'currentColor',
    },
  },
};
</script>
